<template>
  <div class="quote-header">
    <div class="quote-header__left">
      <a class="pages-header__logo" href="/">
        <img src="@/assets/common/header/logo_20230718.svg?v=20230718" alt="华秋电路logo" class="pcb-logo">
      </a>
      <a class="pages-header__quote" href="/quote">
        在线计价下单
      </a>
      <div class="quote-header__links">
        <a class="quote-header__link" target="_blank" href="https://www.hqpcb.com/help/c_59.html">
          下单必看
        </a>
        <a class="quote-header__link" target="_blank" href="https://www.hqpcb.com/help">
          下单帮助
        </a>
        <a class="quote-header__link" target="_blank" href="https://www.hqpcb.com/ability.html">
          制造能力
        </a>
      </div>
    </div>
    <div class="quote-header__right">
      <!-- 已登录 -->
      <div v-if="userInfo && userInfo.sso_uid" class="quote-header__login">
        <a class="quote-header__link" href="/mycenter/order/pcb/list">
          我的订单
        </a>
        <el-dropdown size="small" placement="bottom">
          <a class="quote-header__link quote-header__login__user" target="_blank" href="/mycenter/">
            <i class="el-icon-user-solid user-icon"></i>
            <span class="user-info">
              {{ userInfo.username || 'qaulau' }} ({{ userInfo.sso_uid || '936491' }})
            </span>
            <i class="el-icon-arrow-down user-arrow"></i>
          </a>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="handleLogout">
              退出
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <!-- 未登录 -->
      <div v-else class="quote-header__logout">
        <a href="javascript:void(0)" @click="handleLoginAndReg(0)" class="quote-header__logout__login">
          <img src="@/assets/common/header/icon_login_2x.png?v=20251119" />
          登录
        </a>
        <a href="javascript:void(0)" @click="handleLoginAndReg(1)" class="quote-header__logout__reg">注册</a>
      </div>
    </div>

    <!-- 未登录 -->
    <NotLogin v-show="false" ref="notLoginRef" />
  </div>
</template>

<script>
import NotLogin from './notLogin.vue'

import { mapGetters } from 'vuex'

export default {
  components: {
    NotLogin
  },
  computed: {
    // 用户信息
    ...mapGetters('orderUser', [
      'userInfo',
    ]),
    // 登录、注册返回url
    backAct() {
      return encodeURIComponent(location.href)
    },
    // 区分跳转链接环境
    linkEnv() {
      return {
        'development': 'fat-',
        'fat': 'fat-',
        'uat': 'uat-',
      }[process.env.NODE_ENV] || ''
    }
  },
  methods: {
    handleLoginAndReg(type) {
      // 打开登录弹框
      this.$refs.notLoginRef.handleLogin(type)
    },
    // 退出
    handleLogout() {
      window.location.href = `/account/login/logout.html?returnurl=${this.backAct}`
    }
  },
}
</script>

<style lang="scss" scoped>
// 导航栏
$headerColor: #B60005;
$headerbadgeColor: #05A960;
$headerBgColor: #FFF;
$headerNavHeight: 60px;
$headerZindex: 1000;

.quote-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 12px 15px;
  // border-bottom: 1px solid #E6E6E6;
  background-color: $headerBgColor;

  .quote-header__link {
    display: inline-block;
    padding: 0 13px;
    height: 32px;
    line-height: 32px;
    font-size: 14px;
    text-align: center;
    color: #555555;
    border-radius: 3px;
    &:hover {
      color: #3F96F0;
      text-decoration: underline;
      background-color: #FBFBFB;
    }
  }

  .quote-header__left {
    display: flex;
    align-items: center;
    .pages-header__logo {
      >img {
        display: block;
        height: 36px;
      }
    }
    .pages-header__quote {
      margin-left: 18px;
      font-size: 16px;
      font-weight: 700;
      color: #111111;
    }
    .quote-header__links {
      margin-left: 100px;
      >a {
        margin-right: 5px;
      }
    }
  }

  .quote-header__login {
    .quote-header__login__user {
      display: flex;
      align-items: center;
      margin-left: 10px;
      background-color: #F9F9F9;
      &:hover {
        text-decoration: none;
        .user-info {
          text-decoration: underline;
        }
        .user-arrow {
          transform: rotate(180deg);
        }
      }
      .user-icon {
        font-size: 14px;
      }
      .user-info {
        margin: 0 5px;
      }
      .user-arrow {
        font-size: 12px;
        transition: transform 0.2s;
      }
    }
  }

  .quote-header__logout {
    >a {
      box-sizing: border-box;
      display: inline-block;
      padding: 0 15px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      font-size: 14px;
      border-radius: 16px;
      border: 1px solid #15A675;
      &.quote-header__logout__login {
        color: #fff;
        background-color: #15A675;
        &:hover {
          border-color: #14A070;
          background-color: #14A070;
        }
        >img {
          display: inline-block;
          width: 20px;
          vertical-align: text-top;
        }
      }
      &.quote-header__logout__reg {
        margin-left: 10px;
        color: #15A675;
        &:hover {
          background-color: #F7FCFB;
        }
      }
    }
  }
}
</style>